import styled from '@emotion/styled'
import { breakpoints, colors } from 'src/utils/styles'

export const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  padding-top: ${props => (props.isSmall ? '0.15em' : '0')};
  padding-right: ${props => (props.isSmall ? '0.5em' : '0.75rem')};
  outline: none;
  margin: ${props => (props.isSmall ? '0.15em 0 0 0' : '0')};

  @media (max-width: ${breakpoints.m}px) {
    margin: ${props => (props.isSmall ? '0.10em 0 0 0' : '0')};
  }
`

export const HiddenCheckbox = styled.input`
  clip: rect(0 0 0 0);
  height: 1px;
  position: absolute;
  width: 1px;
`

export const StyledCheckbox = styled.div`
  display: inline-block;
  width: ${props => (props.isSmall ? '15px' : '30px')};
  height: ${props => (props.isSmall ? '15px' : '30px')};
  transition: all 150ms;
  border: 1px solid ${props => (!props.valid ? colors.lobsterRed : colors.darkGray)};

  @media (max-width: ${breakpoints.l}px) {
    width: ${props => (props.isSmall ? '15px' : '23px')};
    height: ${props => (props.isSmall ? '15px' : '23px')};
  }
`

export const StyledCheckmark = styled.img`
  width: ${props => (props.isSmall ? '70%' : '85%')};
  height: auto;
  margin: ${props => (props.isSmall ? '0 0 9px 3px' : '2px 0 0 2px')};

  @media (max-width: ${breakpoints.l}px) {
    margin: ${props => (props.isSmall ? '0 0 7px 3px' : '2px 0 0 2px')};
  }

  @media (max-width: ${breakpoints.m}px) {
    margin: ${props => (props.isSmall ? '0 0 6px 3px' : '2px 0 0 2px')};
  }

  @media (max-width: ${breakpoints.s}px) {
    margin: ${props => (props.isSmall ? '0 0 5px 3px' : '2px 0 0 2px')};
  }
`

export const StyledCross = styled.img`
  width: ${props => (props.isSmall ? '100%' : '85%')};
  height: 14px;
  margin: ${props => (props.isSmall ? '0 0 7.5px 0px' : '2px 0 0 2px')};

  @media (max-width: ${breakpoints.l}px) {
    margin: ${props => (props.isSmall ? '0 0 4px 0' : '2px 0 0 2px')};
  }

  @media (max-width: ${breakpoints.m}px) {
    margin: ${props => (props.isSmall ? '0 0 4px 0' : '2px 0 0 2px')};
  }

  @media (max-width: ${breakpoints.s}px) {
    margin: ${props => (props.isSmall ? '0 0 4px 0' : '2px 0 0 2px')};
  }
`

export const HiddenIcon = styled.img`
  width: ${props => (props.isSmall ? '70%' : '85%')};
  height: auto;
  visibility: hidden;
  margin: ${props => (props.isSmall ? '0 0 8px 3px' : '2px 0 0 2px')};
`
